import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface ChangeOrderSlotVariables {
  order_id: GQL_ID
  slot_id: GQL_ID
}

interface ChangeOrderSlotResponse {
  changeOrderSlot: {
    id: GQL_ID
    status: string
    slot_id: number | null
    deliverySlot: {
      id: GQL_ID
      period: {
        from: string
        to: string
      }
    } | null
  }
}

export const GQL_MUTATION_CHANGE_ORDER_SLOT = gql`
  mutation changeOrderSlot($order_id: ID!, $slot_id: ID!) {
    changeOrderSlot(order_id: $order_id, slot_id: $slot_id) {
      id
      status
      slot_id
      deliverySlot {
        id
        period {
          from
          to
        }
      }
    }
  }
`

export const useMutateChangeOrderSlot = () =>
  useMutation<ChangeOrderSlotResponse, ChangeOrderSlotVariables>(
    GQL_MUTATION_CHANGE_ORDER_SLOT,
  )
